export default "__VITE_ASSET__clJLnufm__"